var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4873 9.74835C14.6157 9.41335 14.6857 9.04949 14.685 8.66924C14.682 7.10687 13.4852 5.82574 11.9594 5.6874C11.6437 3.78984 9.99264 2.34493 8.00614 2.34876C7.70843 2.34933 7.41838 2.38241 7.13934 2.44464M4.86738 3.8787C4.45885 4.39839 4.17633 5.02172 4.06575 5.70259C2.54053 5.84681 1.34867 7.13254 1.35167 8.69491C1.35486 10.3518 2.70059 11.6923 4.35744 11.6891L11.6908 11.675C11.9948 11.6744 12.2882 11.6286 12.5646 11.544M2.00358 1.02698L14.0267 13.0039",
    stroke: "#B8C5CC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOff);
export default __webpack_public_path__ + "static/media/cloud-off.8442d4bf15c979e9f9bfaeebddf07d86.svg";
export { ForwardRef as ReactComponent };